rs.module("development/codedemos/ajax-business-messages",

    ["controls/components/event-banner"],

    function (eventBanner) {

        var _jsSelectors;
        var _backendUrl;
        var _result;

        //
        // Initialize the module
        //
        function initialize(jsSelectors, backendUrl) {

            _jsSelectors = jsSelectors;
            _backendUrl = backendUrl;

            _result = $.js(jsSelectors.result);

            // Hook up click event to clear errors, info, warnings, and all messages
            $.js(_jsSelectors.clearErrorButton).on('click', function () { eventBanner.removeErrorMessages(); });
            $.js(_jsSelectors.clearInfoButton).on('click', function () { eventBanner.removeInformationalMessages(); });
            $.js(_jsSelectors.clearWarningButton).on('click', function () {  eventBanner.removeWarningMessages(); });
            $.js(_jsSelectors.clearAllButton).on('click', function () {  eventBanner.removeAllMessages(); });

            $.js(_jsSelectors.pathSelect).on("change", function () {
                var chosenPath = $.js(_jsSelectors.pathSelect).val();

                _result.html("");

                $.post(
                    {
                        url: _backendUrl,
                        data: { testPath: chosenPath },
                        headers: { "rs-sample": "Bingo!"},
                        clearEventBanner: true
                    })
                    .done(function (result, status, request) {

                        var result = 'Call Succeeded: ' + JSON.stringify(result);

                        if (request.warningsApproved) {
                            result += '.  You just successfully approved a warning.'
                        }

                        _result.html(result);
                    })
                    .fail(function (error) {
                        _result.html("Call Failed: " + error.responseText);
                    });
            })
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);